/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BillingDocument } from '../../models/billing-document';
import { InvoiceDocumentLink } from '../../models/invoice-document-link';

export interface LinkInvoiceDocument$Params {
  uuid: string;
      body: InvoiceDocumentLink
}

export function linkInvoiceDocument(http: HttpClient, rootUrl: string, params: LinkInvoiceDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<BillingDocument>> {
  const rb = new RequestBuilder(rootUrl, linkInvoiceDocument.PATH, 'post');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BillingDocument>;
    })
  );
}

linkInvoiceDocument.PATH = '/invoice-document/{uuid}/link';
